"use strict";
(function(window) {
    window.AppComponent = function () {
        this.$searchResultsElement = $('.js-search-results');
        this.initApp();
    };

    $.extend(window.AppComponent.prototype, {
        initApp: function () {
            var $searchBar = $('.search-bar');
            $(document).foundation();
            this.loadMasonryLayout();
            this.setUpSidebar();

            $('body').on(
                'click',
                '.js-switch-sidebar',
                this.toggleSidebar.bind(this)
            );

            $('.js-sidebar').on(
                'click',
                '.js-sidebar-subtitle',
                this.switchSidebarContent.bind(this)
            );

            $('.js-sidebar').on(
                'click',
                '.js-sidebar-domaine',
                this.loadMuseesByDomaine.bind(this)
            );

            $('.js-sidebar').on(
                'click',
                '.js-sidebar-description-toggler',
                this.displaySidebarDescriptionText.bind(this)
            );

            $('.js-delete-musee-filter').on(
                'click',
                this.removeSearchFilter()
            )
        },

        loadMasonryLayout: function () {
            if ($('#masonry-container').length) {
                $('#masonry-container').masonry({
                    itemSelector: '#masonry-container li'
                });
            }
        },
        removeSearchFilter: function () {
            return function () {
                $('.js-musee-id').val("");
                $('.js-nav-search-form').submit()
            }
        },
        toggleSidebar: function () {
            var self = this;
            var animationDuration = parseFloat($('.sidebar').css('transition-duration')) * 1000;

            setTimeout(function() {
                self.loadMasonryLayout();
            }, animationDuration);

            if( window.mapComponent ) {
                var countInterval = 0;

                var togglingInterval = setInterval(function(){
                    window.mapComponent.refreshMap();

                    if(countInterval > animationDuration) {
                        clearInterval(togglingInterval);
                    }

                    countInterval +=30;
                }, 30);
            }
        },

        setUpSidebar: function () {
            //-- Si nous avons un écran en mode portrait et qu'il fait moins de 640px de large, on affiche pas la sidebar
            if (this.isSmallScreen()) {
                $('.js-main').removeClass('main--sidebar-expanded');
            }
            //--

            //-- Après un court délai, on rajoute les transitions et l'affichage de la sidebar en screen small  pour éviter les animations à chaque chargement
            setTimeout(function() {
                $('.js-main').addClass('main--transition');
                $('.js-sidebar').addClass('sidebar--transition').addClass('sidebar--small-visible');
            },100);
            //--
        },

        switchSidebarContent: function(e) {
            $(e.currentTarget).addClass('is-open').siblings('.js-sidebar-subtitle').removeClass('is-open');

            var targetSidebar = $(e.currentTarget).data('target-sidebar');
            var $sidebarLists = $('.js-sidebar-list');

            $sidebarLists.addClass('hide');
            $sidebarLists.filter('[data-content="' + targetSidebar + '"]').removeClass('hide');
        },

        loadMuseesByDomaine: function(e) {
            var self = this;

            $(e.currentTarget).append('<i class="fa fa-spinner fa-spin js-spinner"></i>');

            $.ajax({
                url: $(e.currentTarget).data('request-path'),
                type: 'GET',
                success: function (data) {
                    //-- Clean URL
                    history.pushState({}, '', '/');
                    //--
                    self.$searchResultsElement.html(data.html);
                    window.mapComponent.initMap();

                    if (self.isSmallScreen()) {
                        $('.js-switch-sidebar').click();
                    }
                },
                complete: function() {
                    $(e.currentTarget).find('.js-spinner').remove();
                }
            });
        },

        isSmallScreen: function() {
            return window.innerWidth <= 640 && window.innerWidth < window.innerHeight
        },

        displaySidebarDescriptionText: function(e) {
            var $chevron = $(e.currentTarget);
            var $chevronIcon = $chevron.find('i');

            if ($chevronIcon.hasClass('fa-chevron-down')) {
                $chevron.siblings('.js-sidebar-description').removeClass('sidebar__description--reduceContent');
                $chevronIcon.addClass('fa-chevron-up');
                $chevronIcon.removeClass('fa-chevron-down');
            } else {
                $chevron.siblings('.js-sidebar-description').addClass('sidebar__description--reduceContent');
                $chevronIcon.removeClass('fa-chevron-up');
                $chevronIcon.addClass('fa-chevron-down');
            }

        }
    });
})(window);
